"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GasContract = void 0;
const consts_1 = require("../../consts");
const manifest_1 = require("../manifest");
const Nep17Contract_1 = require("./Nep17Contract");
const GasTemplateAbi_json_1 = __importDefault(require("./templates/GasTemplateAbi.json"));
let SINGLETON;
class GasContract extends Nep17Contract_1.Nep17Contract {
    static get INSTANCE() {
        if (!SINGLETON) {
            SINGLETON = new GasContract();
        }
        return SINGLETON;
    }
    /**
     * The list of methods found on the GAS contract.
     */
    static getMethods() {
        return GasTemplateAbi_json_1.default.methods.map((m) => manifest_1.ContractMethodDefinition.fromJson(m));
    }
    constructor() {
        super(consts_1.NATIVE_CONTRACT_HASH.GasToken, GasContract.getMethods());
    }
}
exports.GasContract = GasContract;
